const initialState = {
  REDIRECT_DURATION: 60000,

  HOME_BUTTON_LIST_PADDING: 24,
  HOME_BUTTON_LIST_ITEM_HEIGHT: 112,
  HOME_BUTTON_LIST_ITEM_MARGIN: 1,
  HOME_BUTTON_LIST_ITEM_FONT_SIZE: 28,
  HOME_BUTTON_LIST_ITEM_BORDER_RADIUS: 4,
  HOME_BUTTON_INSTRUCTION_FONT_SIZE: 24,
  HOME_BUTTON_INSTRUCTION_MARGIN_BOTTOM: 24,
  HOME_VENDOR_MARGIN: 24,
  HOME_VENDOR_WELCOME_FONT_SIZE: 16,
  HOME_VENDOR_WELCOME_MARGIN_BOTTOM: 8,
  HOME_VENDOR_LOGO_SIZE: 160,
  HOME_MICROPHONE_SIZE: 400,
  HOME_MICROPHONE_MARGIN_BOTTOM: -160,
  HOME_INSTRUCTIONS_FONT_SIZE: 72,
  HOME_INSTRUCTIONS_PADDING_HORIZONTAL: 96,
  HOME_INSTRUCTIONS_MARGIN_TOP: 144,
  HOME_HANDLE_SIZE: 64,
  HOME_HANDLE_MARGIN_BOTTOM: 24,

  SIGN_LOADER_SIZE: 240,
  SIGN_LINE_ONE_FONT_SIZE: 32,
  SIGN_LINE_TWO_FONT_SIZE: 24,
  SIGN_SIGN_LARGE_FONT_SIZE: 112,
  SIGN_SIGN_SMALL_FONT_SIZE: 72,
  SIGN_ANIMATION_DISTANCE: 24,
  SIGN_INFO_MARGIN: 24,

  KEY_FIELD_HEIGHT: 152,
  KEYFIELD_WRAPPER_PADDING_TOP: 24,
  KEYFIELD_MESSAGE_FONT_SIZE: 24,
  KEYFIELD_MESSAGE_HEIGHT: 32,
  KEYFIELD_MESSAGE_MARGIN_BOTTOM: 24,
  KEYFIELD_FIELD_WIDTH: 304,
  KEYFIELD_FIELD_HEIGHT: 72,
  KEYFIELD_CURSOR_WIDTH: 4,
  KEYFIELD_CURSOR_HEIGHT: 32,
  KEYFIELD_NUMBER_FONT_SIZE: 32,
  KEYFIELD_NUMBER_HEIGHT: 32,
  KEYFIELD_NUMBER_WIDTH: 255,
  KEYFIELD_CURSOR_LEFT_POSITIONS: [
    -8,
    18,
    40,
    82,
    104,
    126,
    168,
    188,
    210,
    232,
    252
  ],

  KEY_CONTROL_HEIGHT: 152,
  KEY_CHECK_SIZE: 240,
  KEY_THANK_YOU_HEIGHT: 340,

  KEYFORM_KEY_HEIGHT: 72,
  KEYFORM_KEY_FONT_SIZE: 24,
  KEYFORM_SPACER_SIZE: 8,
  KEYFORM_BUTTON_HEIGHT: 72,
  KEYFORM_BUTTON_FONT_SIZE: 24,
  KEYFORM_BUTTON_PADDING_HORIZONTAL: 64,

  KEY_THANK_YOU_MESSAGE_FONT_SIZE: 24,
  KEY_THANK_YOU_MESSAGE_MARGIN_BOTTOM: 48,
  KEY_THANK_YOU_MESSAGE_PADDING_HORIZONTAL: 72,
  KEY_THANK_YOU_BUTTON_HEIGHT: 72,
  KEY_THANK_YOU_BUTTON_FONT_SIZE: 24,
  KEY_THANK_YOU_BUTTON_PADDING_HORIZONTAL: 64,

  KEYCONTROL_WRAPPER_PADDING_TOP: 48,
  KEYCONTROL_WRAPPER_PADDING_BOTTOM: 48,
  KEYCONTROL_BUTTON_HEIGHT: 72,
  KEYCONTROL_BUTTON_FONT_SIZE: 24,
  KEYCONTROL_BUTTON_PADDING_HORIZONTAL: 64
};

export default function(state) {
  if (typeof state === 'undefined') {
    return initialState;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/constants/index.js